import React from 'react';
import rossImage from '../images/headliner_ROSS_allstar2026_v3_1770587833138.JPG';

function Event3() {
  return (
    <div>
      {/* Event Hero */}
      <section className="event-hero">
        <div className="hero-content">
          <p className="hero-subtitle">Sunday, February 15, 2026</p>
          <div style={{display: 'flex', justifyContent: 'center', margin: '2rem 0'}}>
            <a href="https://www.eventbrite.com/e/nba-all-star-game-weekend-finale-celebrating-rick-ross-birthday-tickets-1982413382793?aff=oddtdtcreator" target="_blank" rel="noopener noreferrer">
              <img
                src={rossImage}
                alt="Rick Ross NBA Allstar Weekend Finale Party"
                style={{maxWidth: '40%', height: 'auto', borderRadius: '8px', cursor: 'pointer'}}
              />
            </a>
          </div>
          <p className="hero-description" style={{textAlign: 'center'}}>
            <strong>NBA All-Star Game Weekend Finale</strong><br/>
            Celebrating Rick Ross' Birthday<br/><br/>

            End NBA All-Star Game Weekend in legendary fashion at the official All-Star Weekend Finale, celebrating the birthday of hip-hop icon Rick Ross hosted by French Montana.<br/><br/>

            This is the grand finale party—where the city comes together one last time to close out All-Star Weekend with luxury, energy, and unforgettable vibes. Expect a packed room, elite DJs, celebrity guests, and a high-end nightlife experience fitting for a boss-level celebration.<br/><br/>

            If you've been outside all weekend, this is the night you don't miss.<br/><br/>

            <strong>🎉 EVENT HIGHLIGHTS</strong><br/>
            Official NBA All-Star Weekend Finale<br/>
            Rick Ross Birthday Celebration<br/>
            Celebrity & industry crowd<br/>
            Top DJs & nonstop energy<br/>
            Premium nightlife experience<br/><br/>

            <strong>🎟️ TICKETS & ADMISSION</strong><br/>
            FINAL NIGHT OF ALL-STAR WEEKEND<br/><br/>

            This Weekend (Fri–Sun):<br/>
            $30 Early Bird<br/>
            $50 VIP Skip-the-Line<br/><br/>

            Monday–Friday Pricing:<br/>
            $50 General Admission<br/>
            $75 VIP Skip-the-Line<br/><br/>

            🚨 VIP tickets include expedited entry but do not include table seating.<br/><br/>

            <strong>🍾 TABLES & VIP EXPERIENCE</strong><br/>
            Table reservations provide premium seating, bottle service, and the ultimate All-Star Weekend send-off experience.<br/><br/>

            <strong>📩 CONTACT & INQUIRIES</strong><br/>
            For table reservations, press/media, or general information, please contact:<br/>
            📧 info@supremeteamla.com<br/><br/>

            This is the final night, the biggest celebration, and the perfect close to All-Star Weekend. Tickets will sell fast — secure yours now.<br/><br/>

            21 and over age limit event
          </p>
        </div>
      </section>

      {/* Event Details */}
      {/* <section className="event-details">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Event Details</h2>
          </div>

          <div className="event-info-grid">
            <div className="info-box">
              <div className="info-label">Date & Time</div>
              <div className="info-value">Saturday, February 15, 2026<br/>9:00 PM </div>
            </div>

            <div className="info-box">
              <div className="info-label">Duration</div>
              <div className="info-value">Approximately 45 minutes</div>
            </div>

            <div className="info-box">
              <div className="info-label">Participants</div>
              <div className="info-value">8 Versatile Players</div>
            </div>

            <div className="info-box">
              <div className="info-label">Prize</div>
              <div className="info-value">$25,000 Winner</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* About Section */}
      <section className="section">
        <div className="container">
          {/* <div className="section-header">
            <h2 className="section-title">About The Challenge</h2>
          </div> */}

          <div style={{maxWidth: '900px', margin: '0 auto'}}>
            {/* <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              The Skills Challenge tests the complete basketball player. This timed obstacle course requires participants to demonstrate ball-handling, passing accuracy, agility, and shooting ability all in rapid succession. It's a showcase of the modern NBA player's versatility.
            </p>

            <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              Players navigate through a challenging course featuring dribbling stations around obstacles, precision passing through targets, and shooting from multiple positions. Each element must be completed successfully before advancing, with the clock relentlessly ticking.
            </p>

            <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '2rem'}}>
              The competition features head-to-head matchups in a bracket format. Speed is crucial, but accuracy determines advancement. One missed pass or failed shot can cost precious seconds and ultimately the competition.
            </p> */}

            <div style={{textAlign: 'center', marginTop: '3rem'}}>
              <a href="https://www.eventbrite.com/e/nba-all-star-game-weekend-finale-celebrating-rick-ross-birthday-tickets-1982413382793?aff=oddtdtcreator" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Get Tickets</a>
            </div>
          </div>
        </div>
      </section>

      {/* Course Breakdown */}
      {/* <section className="section" style={{background: 'var(--dark-gray)'}}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Course Breakdown</h2>
          </div>

          <div className="events-grid">
            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">01</span>
              <h3>Ball Handling</h3>
              <p>
                Navigate through a series of obstacles while maintaining control of the basketball. Players must weave through cones with precision and speed, showcasing elite dribbling skills.
              </p>
            </div>

            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">02</span>
              <h3>Passing Accuracy</h3>
              <p>
                Hit specific targets with chest passes and bounce passes. Precision is paramount as missed targets require retrieval and retry, eating valuable seconds off the clock.
              </p>
            </div>

            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">03</span>
              <h3>Three-Point Shot</h3>
              <p>
                Sink a three-pointer from a designated spot. Players can take multiple attempts, but the clock never stops. The pressure mounts with each miss as opponents complete their runs.
              </p>
            </div>

            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">04</span>
              <h3>Final Sprint</h3>
              <p>
                Complete a layup on the opposite end to stop the clock. The fastest times advance through the bracket until a champion is crowned in the final head-to-head matchup.
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default Event3;
